
// @ts-nocheck
import locale_en_46json_b53d8f52 from "#nuxt-i18n/b53d8f52";
import locale_vi_46json_ee9e952f from "#nuxt-i18n/ee9e952f";
import locale_ar_46json_7c2eaf44 from "#nuxt-i18n/7c2eaf44";

export const localeCodes =  [
  "en",
  "vi",
  "ar"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_b53d8f52",
      load: () => Promise.resolve(locale_en_46json_b53d8f52),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46json_ee9e952f",
      load: () => Promise.resolve(locale_vi_46json_ee9e952f),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_7c2eaf44",
      load: () => Promise.resolve(locale_ar_46json_7c2eaf44),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      files: [
        {
          path: "/app/50-ftd-20-frl-gllo/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "vi",
      language: "vi",
      files: [
        {
          path: "/app/50-ftd-20-frl-gllo/i18n/locales/vi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      language: "ar",
      files: [
        {
          path: "/app/50-ftd-20-frl-gllo/i18n/locales/ar.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "/50-ftd-20-frl-gllo/",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    files: [
      {
        path: "/app/50-ftd-20-frl-gllo/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "vi",
    language: "vi",
    files: [
      {
        path: "/app/50-ftd-20-frl-gllo/i18n/locales/vi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    language: "ar",
    files: [
      {
        path: "/app/50-ftd-20-frl-gllo/i18n/locales/ar.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/